/* Keep circular card controls accessible after swatch and homepage changes. */
(() => {
  'use strict';
  const selector = '.product-item .card-action .button-ATC, .mc-home-action .button-ATC';
  function label(button) {
    // Upgrade older asynchronously loaded cards to the same options flow.
    if (!button.disabled && !button.hasAttribute('disabled') && !button.hasAttribute('data-btn-addtocart') && !button.hasAttribute('data-open-quick-view-popup')) {
      const handle = button.dataset.productHandle || button.getAttribute('href')?.match(/\/products\/([^?#/]+)/)?.[1];
      if (handle) {
        button.dataset.productHandle = handle;
        button.removeAttribute('data-quickshop-popup');
        button.setAttribute(button.classList.contains('is-notify-me') ? 'data-btn-addtocart' : 'data-open-quick-view-popup', '');
      }
    }
    // Keep a generous invisible target without enlarging the visible round icon.
    if (!button.querySelector('.mc-cart-hit-area')) {
      const hitArea = document.createElement('span');
      hitArea.className = 'mc-cart-hit-area';
      hitArea.setAttribute('aria-hidden', 'true');
      button.appendChild(hitArea);
    }
    const text = button.classList.contains('is-notify-me') ? 'Notify me' :
      button.classList.contains('is-soldout') || button.disabled ? 'Sold out' :
      button.hasAttribute('data-open-quick-view-popup') || button.hasAttribute('data-quickshop-popup') ? 'Choose options' : 'Add to cart';
    if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
    if (button.title !== text) button.title = text;
  }
  function initialize(root) {
    if (root.matches?.(selector)) label(root);
    root.querySelectorAll?.(selector).forEach(label);
  }
  function updateHomeCard(card, product) {
    const button = card.querySelector('.mc-home-action .button-ATC');
    if (!button) return;
    const form = button.closest('form');
    form.querySelector('[name="id"]').value = product.variantId;
    card.dataset.productId = product.id;
    const title = card.querySelector('.card-title');
    title.href = product.url; title.dataset.productTitle = product.title; title.dataset.productUrl = product.url;
    button.removeAttribute('data-btn-addtocart'); button.removeAttribute('data-open-quick-view-popup');
    button.classList.toggle('is-notify-me', product.available === false);
    button.dataset.productId = product.id; button.dataset.productHandle = product.handle;
    if (product.available === false || product.variantCount === 1) {
      button.setAttribute('data-btn-addtocart', '');
      button.type = product.available === false ? 'button' : 'submit';
    } else {
      button.type = 'button'; button.setAttribute('data-open-quick-view-popup', '');
    }
    label(button);
  }
  function copyPickerQuantity(popup) {
    const visible = popup?.querySelector('.quantity_selector input[name="quantity"]');
    if (!visible) return;
    popup.querySelectorAll('form input[name="quantity"]').forEach(input => { input.value = visible.value; });
  }
  document.addEventListener('input', event => {
    if (event.target.matches('#halo-quick-view-popup .quantity_selector input[name="quantity"]')) copyPickerQuantity(event.target.closest('#halo-quick-view-popup'));
  });
  document.addEventListener('click', event => {
    // Card actions are controls, even when legacy markup renders them as links.
    // Preserve the theme's delegated handler, but never follow the product href.
    if (event.target.closest(selector)) event.preventDefault();
    const submit = event.target.closest('#halo-quick-view-popup [data-btn-addtocart]');
    if (submit) copyPickerQuantity(submit.closest('#halo-quick-view-popup'));
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.closest('#halo-quick-view-popup')) copyPickerQuantity(event.target.closest('#halo-quick-view-popup'));
  }, true);
  window.MannatsCardActions = {updateHomeCard};
  initialize(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') initialize(record.target);
    else {
      // Swatch changes can replace all children of an existing button.
      if (record.target.matches?.(selector)) label(record.target);
      record.addedNodes.forEach(node => { if (node.nodeType === 1) initialize(node); });
    }
  })).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled', 'data-quickshop-popup', 'data-open-quick-view-popup']});
})();
